<template>
    <div>
      <vue-good-table mode="remote" @on-page-change="onPageChange" @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange" :totalRows="table.total_records"
        :isLoading.sync="table.isLoading" :pagination-options="{
            enabled: true,
            dropdownAllowAll: false,
            perPageDropdown: [10, 25, 50, 100],
          }" :columns="table.columns" :rows="table.rows">
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'action'">
            <router-link :to="'/admin/node-server/edit?id=' + props.row.id">
              <a class="btn btn-primary text-white margin5">Edit</a>
            </router-link>
            <a v-on:click="deleteNodeServer(props.row.id)" class="btn btn-danger text-white margin5">
              Hapus
            </a>
          </span>
          <span v-else-if="props.column.field == 'active'">
            <span v-if="props.row.active == 1" class="badge badge-success">Aktif</span>
            <span v-else class="badge badge-danger">Tidak Aktif</span>
          </span>
          <span v-else-if="props.column.field == 'multidevice'">
            <span v-if="props.row.multidevice == 1" class="badge badge-info">Multi Device</span>
            <span v-else class="badge badge-secondary">Single Device</span>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </div>
  </template>
  
  <script>
    export default {
      data() {
        return {
          table: {
            total_records: 0,
            isLoading: true,
            columns: [{
                label: "Server URL",
                field: "url",
                filterOptions: {
                  enabled: true,
                },
                sortable: false,
                width: "30%",
              },
              {
                label: "Multidevice",
                field: "multidevice",
                filterOptions: {
                  enabled: true,
                },
                sortable: false,
                width: "15%",
              },
              {
                label: "Token",
                field: "token",
                filterOptions: {
                  enabled: true,
                },
                sortable: false,
                width: "25%",
              },
              {
                label: "Device Connected",
                field: "connected_count",
                sortable: false,
                width: "12%",
              },
              {
                label: "Status",
                field: "active",
                filterOptions: {
                  enabled: true,
                },
                sortable: false,
                width: "15%",
              },
              {
                label: "Action",
                field: "action",
                sortable: false,
                width: "15%",
              },
            ],
            rows: [],
            params: {
              page: 1,
              limit: 10,
              columnFilters: {},
            },
          },
        };
      },
      beforeDestroy(){
        this.$root.$off("refresh_table", this.fnRefreshTable);
      },
      mounted() {
        this.fnRefreshTable = () => {
          this.loadData();
        }
        this.$root.$on("refresh_table", this.fnRefreshTable);
        this.loadData();
      },
      methods: {
        async loadData() {
          this.table.isLoading = true;
          try {
            let response = await this.$store.dispatch('admin_node_servers_list', this.table.params);
            this.table.rows = response.data.data.node_servers || [];
            this.table.total_records = this.table.rows.length;
          } catch (err) {
            this.$toast.error(err.response?.data?.message || "Failed to load node servers");
          } finally {
            this.table.isLoading = false;
          }
        },
        async deleteNodeServer(id) {
          if (confirm("Yakin ingin menghapus node server ini?")) {
            try {
              let response = await this.$store.dispatch('admin_node_server_delete', { id: id });
              this.$toast.success(response.data.message);
              this.$root.$emit("refresh_table", true);
            } catch (err) {
              this.$toast.error(err.response?.data?.message || "Failed to delete node server");
            }
          }
        },
        onPageChange(params) {
          this.table.params.page = params.currentPage;
          this.loadData();
        },
        onPerPageChange(params) {
          this.table.params.limit = params.currentPerPage;
          this.loadData();
        },
        onSortChange() {
          // Handle sort if needed
        },
        onColumnFilter(params) {
          this.table.params.columnFilters = params;
          this.loadData();
        },
      },
    };
  </script>
  
  <style scoped>
  
  </style>

